import React from "react";


// import images
import fullbody from "../images/fullbody.webp";
import underarms from "../images/underarms.webp";
import arms from "../images/arms.webp";
import facial from "../images/facial.webp";
import legs from "../images/legs.webp";
import back from "../images/back.webp";
import  chin from "../images/chin.webp";
import  beard from "../images/beard.webp";
import chest  from "../images/chest.webp";
import spot from "../images/spot.webp";


const services = [
  {
    title: "Full Body Laser Hair Removal",
    img: fullbody,
    points: ["Head-to-Toe Coverage", "Single Package Value"],
    type: "both",
  },
  {
    title: "Underarms Laser Hair Removal",
    img: underarms,
    points: ["Odor Control", "Pigmentation Reduction"],
    type: "both",
  },
  {
    title: "Arms Laser Hair Removal",
    img: arms,
    points: ["Sleeve-Free Confidence", "Even Texture"],
    type: "both",
  },
  {
    title: "Facial Laser Hair Removal",
    img: facial,
    points: ["Makeup Ready Skin", "Upper Lip Precision"],
    type: "both",
  },
  {
    title: "Legs Laser Hair Removal",
    img: legs,
    points: ["Reduces regrowth", "Low maintenance care"],
    type: "both",
  },
  {
    title: "Back Laser Hair Removal",
    img: back,
    points: ["Sweat-free comfort", "Hair-free back"],
    type: "both",
  },
  {
    title: "Chin Laser Hair Removal",
    img: chin,
    points: ["No skin darkening", "Safe for sensitive"],
    type: "both",
  },
  {
    title: "Laser Spot Removal",
    img: spot,
    points: ["Beach-Ready Skin", "Zero Ingrowns"],
    type: "both",
  },
  {
    title: "Beard Shaping",
    img: beard,
    points: ["Defined Jawline", "Sharp Contours"],
    type: "male",
  },
  {
    title: "Chest Laser Hair Removal",
    img: chest,
    points: ["Sweat Control", "Clean Aesthetic"],
    type: "male",
  },
];

const Services = () => {
  return (
    <div className="service-container">
      {services.map((item, index) => (
        <div className="service-card" key={index}>
          
          {/* Center Image */}
          <div className="image-box">
            <img src={item.img} alt={item.title} />
          </div>

          <h3>{item.title}</h3>

          <ul>
            {item.points.map((point, i) => (
              <li key={i}>✔ {point}</li>
            ))}
          </ul>

          <div className="btn-group">
            {(item.type === "both" || item.type === "female") && (
              <a href="tel: 9239597019">
              <button>FEMALE</button></a>
            )}
            {(item.type === "both" || item.type === "male") && (
               <a href="tel: 9239597019">
              <button>MALE</button></a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Services;